/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"

const base = { position: "relative" }

const flex = { display: "flex", flexShrink: 0 }

const grid = { display: "grid" }

function Column({
  as: ComponentType = "div",
  align = undefined,
  justify = undefined,
  wrap = undefined,
  ...props
}) {
  return (
    <ComponentType
      sx={{
        ...base,
        ...flex,
        flexDirection: "column",
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : "nowrap",
      }}
      {...props}
    />
  )
}

function Row({
  as: ComponentType = "div",
  align = undefined,
  justify = undefined,
  wrap = undefined,
  ...props
}) {
  return (
    <ComponentType
      sx={{
        ...base,
        ...flex,
        flexDirection: "row",
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : "nowrap",
      }}
      {...props}
    />
  )
}

function Flex({
  as: ComponentType = "div",
  align = undefined,
  justify = undefined,
  wrap = undefined,
  direction = undefined,
  ...props
}) {
  return (
    <ComponentType
      sx={{
        ...base,
        ...flex,
        flexDirection: direction || "column",
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap ? "wrap" : "nowrap",
      }}
      {...props}
    />
  )
}

function Grid({
  as: ComponentType = "div",
  columns = undefined,
  rows = undefined,
  gap = undefined,
  ...props
}) {
  return (
    <ComponentType
      sx={{ ...base, ...grid, gridTemplateColumns: columns, gridTemplateRows: rows, gridGap: gap }}
      {...props}
    />
  )
}

function SectionGrid({ as: ComponentType = "div", Ref, ...props }) {
  return (
    <ComponentType
      sx={{
        display: ["block", "block", "grid"],
        gridTemplateColumns: "1fr minmax(25px, 200px) minmax(700px, 900px) minmax(25px, 200px) 1fr",
      }}
      ref={Ref}
      {...props}
    />
  )
}

function Wide({ as: ComponentType = "div", ...props }) {
  return (
    <ComponentType
      sx={{
        gridColumn: "2 / span 3",
      }}
      {...props}
    />
  )
}

function Narrow({ as: ComponentType = "div", ...props }) {
  return (
    <ComponentType
      sx={{
        gridColumn: "3 / span 1",
      }}
      {...props}
    />
  )
}
Flex.column = Column

Flex.row = Row

SectionGrid.wide = Wide

SectionGrid.narrow = Narrow

export { Flex, Grid, SectionGrid }
